import * as React from "react";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";

import {CustomerBlackList} from "../../domain/model/customer_black_list";

import {AppState} from "../store/app_state";
import {CustomerBlackListState} from "../store/customer_black_list_state";
import {AuthState} from "../store/auth_state";
import {createCustomerBlackListActionCreator} from "../action/customer_black_list_action";
import {
    createCustomerBlackListDispatcher,
    ICustomerBlackListDispatcher,
} from "../dispatcher/customer_black_list_dispatcher";

import {
    AddCustomerBlackListRequest,
    DeleteCustomerBlackListRequest,
    GetCustomerBlackListRequest,
} from "../request/customer_black_request";

import CustomerBlackListComponent from "../component/customer/black_list/customer_black_list";
import {
    createAppNotificationMessageDispatcher,
    IAppNotificationMessageDispatcher
} from "../dispatcher/app_notification_message_dispatcher";
import {createAppNotificationMessageActionCreator} from "../action/app_notification_message_action";
import {AppNotificationMessageState} from "../store/app_notification_message_state";
import {AddAppNotificationRequest} from "../request/app_notification_message_request";
import {AppNotificationType} from "../../domain/model/app_notification_message";
import {CustomerBlackListError} from "../../config/view_const/customer_black_list";

interface IProps extends RouteComponentProps<{action: string}>{
    state: CustomerBlackListState;
    authState: AuthState;
    notificationState: AppNotificationMessageState;
    dispatcher: ICustomerBlackListDispatcher;
    notificationDispatcher: IAppNotificationMessageDispatcher;
}

interface IState {
    isInit: boolean;
    anchorEl: any
}

export class CustomerBlackListContainer extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isInit: true,
            anchorEl: null,
        };

    };

    public componentDidMount() {
        if (this.props.authState.user && this.props.authState.user.customer) {
            const customerId: string = this.props.authState.user.customer.id;
            const reqGet: GetCustomerBlackListRequest = new GetCustomerBlackListRequest();
            reqGet.customerId = customerId;
            this.props.dispatcher.getCustomerBlackList(reqGet);
        }
    };

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean = this.state.isInit && !this.props.state.isLoading && prevProps.state.isLoading;
        if (isInitFinished) { return this.setState({isInit: false}) }
    };

    public render(): JSX.Element {

        const {match, state} = this.props;
        const {isInit} = this.state;

        const isLoading: boolean = state.isLoading;
        const customerBlackList: CustomerBlackList | null = state.customerBlackList;

        return (
            <CustomerBlackListComponent
                isInit={isInit}
                isLoading={isLoading}
                match={match}
                customerBlackList={customerBlackList}
                anchorEl={this.state.anchorEl}
                handleClose={this.handleDropDownClose}
                handleClick={this.handleDropDownClick}
                handleAddCustomerBlackListSubmit={this.handleAddCustomerBlackListSubmit}
                handleDeleteCustomerBlackListSubmit={this.handleDeleteCustomerBlackListSubmit}
            />
        )
    };

    private handleAddCustomerBlackListSubmit = (values: any): void => {
        if (this.props.authState.user && this.props.authState.user.customer) {
            const customerId: string = this.props.authState.user.customer.id;
            const domains: string[] = this.props.state.customerBlackList ? this.props.state.customerBlackList.domains : [];

            const reqAdd: AddCustomerBlackListRequest = new AddCustomerBlackListRequest();
            reqAdd.customerId = customerId;
            reqAdd.domains = domains;
            reqAdd.domain = values.domain;
            this.props.dispatcher.addCustomerBlackList(reqAdd);
        } else {
            const reqNotification: AddAppNotificationRequest = new AddAppNotificationRequest();
            reqNotification.type = AppNotificationType.ERROR;
            reqNotification.message = CustomerBlackListError.authError;
            this.props.notificationDispatcher.add(reqNotification);
        }
    };

    private handleDeleteCustomerBlackListSubmit = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        if (this.props.authState.user && this.props.authState.user.customer) {
            const customerId: string = this.props.authState.user.customer.id;
            const domains: string[] = this.props.state.customerBlackList ? this.props.state.customerBlackList.domains : [];
            const index: number = Number(event.currentTarget.value);

            const reqDelete: DeleteCustomerBlackListRequest = new DeleteCustomerBlackListRequest();
            reqDelete.customerId = customerId;
            reqDelete.domains = domains;
            reqDelete.index = index;
            this.props.dispatcher.deleteCustomerBlackList(reqDelete);
        } else {
            const reqNotification: AddAppNotificationRequest = new AddAppNotificationRequest();
            reqNotification.type = AppNotificationType.ERROR;
            reqNotification.message = CustomerBlackListError.authError;
            this.props.notificationDispatcher.add(reqNotification);
        }
    };

    private handleDropDownClick = (event: any): void => {
        this.setState({anchorEl: event.currentTarget});
    };

    private handleDropDownClose = (): void => {
        this.setState({anchorEl: null});
    };

}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.customerBlackListReducer,
        authState: state.authReducer,
        notificationState: state.appNotificationMessageReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createCustomerBlackListDispatcher(dispatch, createCustomerBlackListActionCreator()),
        notificationDispatcher: createAppNotificationMessageDispatcher(dispatch, createAppNotificationMessageActionCreator()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerBlackListContainer);



// WEBPACK FOOTER //
// ./src/presentation/container/cusotmer_black_list_conatainer.tsx